const SUGGESTION_LIST = {
    "free-agilite-tourniquet-holder-copy":["combat-application-tourniquet-c-a-t"],
    "tourniquet-holder":["combat-application-tourniquet-c-a-t"],
    "free-agilite-tourniquet-holder":["combat-application-tourniquet-c-a-t"],
    "magnetix-battle-belt": [
      ['pincer-single-556-mag-pouch'],
      ['mag-release-dump-pouch'],
      ['pincer-pistol-single-pouch'],
      ['md2-compact-trauma-kit'],
      ['md2-compact-trauma-kit-contents'],
      ['tourniquet-holder'],
      ['combat-application-tourniquet-c-a-t'],
      ['glove-hanger']
    ],
    "magnetix-battle-belt-copy": [
      ['pincer-single-556-mag-pouch'],
      ['mag-release-dump-pouch'],
      ['pincer-pistol-single-pouch'],
      ['md2-compact-trauma-kit'],
      ['md2-compact-trauma-kit-contents'],
      ['tourniquet-holder'],
      ['combat-application-tourniquet-c-a-t'],
      ['glove-hanger']
    ],
    "amap-iii-assault-pack": [
      ['hook-backed-edc-organizer-panel'],
      ['padded-laptop-sleeve'],
    ],
    "free-builder-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "easter-bunny-scorpion-patch-new": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "agilite-free-easter-bunny-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "agilite-easter-bunny-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "easter-rabbit-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "agilite-easter-rabbit-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "free-easter-rabbit-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-germany-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-france-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-italy-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-uk-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-alpha-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-belgium-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "testing-team-netherlands-hat": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "cyber-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["general-purpose-pouch-small"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "belgium-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "denmark-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "estonia-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "lithuania-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "netherlands-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "poland-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "sweden-flag-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "neon-green-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "red-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "red-scorpion-patch": [
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-beanie"]
    ],
    "neon-red-scorpion-patch": [
      ["agilite-multicam-trucker-hat"],
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-logo-hat"]
    ],"statue-of-liberty-blue-scorpion-patch": [
      ["agilite-multicam-trucker-hat"],
        ["ir-us-flag-patch"],
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-logo-hat"]
    ],
    "uncle-sam-scorpion-patch": [
      ["agilite-multicam-trucker-hat"],
      ["emergence-fanny-pack"],
        ["ir-us-flag-patch"],
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-logo-hat"]
    ],
    "statue-of-liberty-red-scorpion-patch": [
      ["agilite-multicam-trucker-hat"],
        ["ir-us-flag-patch"],
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-logo-hat"]
    ],
    "statue-of-liberty-scorpion-patch": [
      ["agilite-multicam-trucker-hat"],
        ["ir-us-flag-patch"],
      ["re-flex-rifle-sling"],
      ["scorpion-patch"],
      ["pincer-pistol-single-pouch"],
      ["tourniquet-holder"],
      ["combat-application-tourniquet-c-a-t"],
      ["scorpion-logo-hat"]
    ],
    "micro-map": [
      ["agilite-sapi-hydration-bladder"]
    ]
    
}

// Product cache to avoid duplicate requests
const productCache = new Map();
const pendingRequests = new Map();

// Detect the current product handle
const currentProductHandle = window.ShopifyProduct?.handle;

// ===== Product Data Fetching =====
async function fetchProductData(handle) {
    if (!handle) return null;

    if (productCache.has(handle)) return productCache.get(handle);
    if (pendingRequests.has(handle)) return pendingRequests.get(handle);

    const p = (async () => {
        try {
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            const product = await res.json();
            if (!product?.variants?.length) throw new Error('Product has no variants');

            // Cap cache size (only evict when exactly at limit for efficiency)
            if (productCache.size === 20) {
                const first = productCache.keys().next().value;
                productCache.delete(first);
            }
            productCache.set(handle, product);
            return product;
        } catch (e) {
            console.warn('[EasySuggest] Failed to fetch product:', handle, e);
            return null;
        } finally {
            pendingRequests.delete(handle);
        }
    })();

    pendingRequests.set(handle, p);
    return p;
}

// ===== Variant Selection Logic =====
/**
 * Gets the color value from a variant (usually from options[0] or title)
 * @param {Object} variant - Variant object
 * @returns {string|null} Color value or null
 */
function getVariantColor(variant) {
    if (!variant) return null;
    
    // Try to get color from options (usually first option is color)
    if (variant.options && variant.options.length > 0) {
        const colorOption = variant.options[0];
        if (colorOption && typeof colorOption === 'string') {
            return colorOption.toLowerCase().trim();
        }
    }
    
    // Fallback: try to extract from title
    if (variant.title) {
        const titleParts = variant.title.split(' / ');
        if (titleParts.length > 0) {
            return titleParts[0].toLowerCase().trim();
        }
    }
    
    return null;
}

// Preferred colour-substitution order when the requested colour is sold out —
// a local copy of the gear builder's Store.COLOR_FALLBACK_MAP (the easy widget
// runs on standard PDPs where the AGB Store module may not be loaded, so it
// can't reach that map). Keep the two in sync.
// Keys + values are LOWERCASE: getVariantColor() lowercases every colour, and
// targetColor comes from it, so the map is looked up + compared in lowercase.
const EASY_COLOR_FALLBACK_MAP = {
    'multicam': ['coyote tan', 'coyote brown', 'ranger green'],
    'multicam black': ['black', 'ranger green'],
    'ranger green': ['multicam', 'black', 'coyote tan'],
    'black': ['multicam black', 'ranger green'],
    'm81 woodland': ['multicam', 'ranger green'],
    'coyote brown': ['coyote tan', 'multicam'],
    'coyote tan': ['coyote brown', 'multicam'],
};

/**
 * Finds a variant to display for the target colour, preferring IN-STOCK.
 * When the requested colour is sold out we DO NOT return that out-of-stock
 * variant — we substitute the next available colour (preferred order, then any
 * available), exactly like the gear builder's pickVariantForDisplay. Only when
 * NO colour is in stock at all does it return an out-of-stock variant (so the
 * card can render its "Sold out" state).
 * @param {Object} product - Product object
 * @param {string|null} targetColor - Target color to match
 * @returns {Object|null} Display variant
 */
// Multicam <-> Coyote Tan interchangeable (Dorian 2026-07-13): item not offered
// in the requested colour but offered in the other => use the other. Both
// directions, EXISTENCE-based. Panel flag `multicamTanSwap` (default ON).
function _mcTanRemap(variants, targetColor, colorOf) {
    try {
        var gs = window.__AGB_GEAR_SUGG;
        if (gs && gs.raw && gs.raw.multicamTanSwap === false) return targetColor;
        var equiv = (targetColor === 'Multicam') ? 'Coyote Tan'
                  : (targetColor === 'Coyote Tan') ? 'Multicam' : null;
        if (!equiv || !Array.isArray(variants)) return targetColor;
        var has = function (c) { return variants.some(function (v) { return colorOf(v) === c; }); };
        if (has(targetColor)) return targetColor;
        return has(equiv) ? equiv : targetColor;
    } catch (e) { return targetColor; }
}

function getMatchingVariant(product, targetColor = null) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
        return null;
    }
    const variants = product.variants;
    if (targetColor) targetColor = _mcTanRemap(variants, targetColor, getVariantColor);

    // No target color specified: first available, else first variant.
    if (!targetColor) {
        return variants.find(v => v.available === true) || variants[0] || null;
    }

    // 1) Requested colour, IN STOCK.
    const sameInStock = variants.find(v => v.available && getVariantColor(v) === targetColor);
    if (sameInStock) return sameInStock;

    // 2) Preferred substitute colours, IN STOCK (Multicam → Coyote Tan → …).
    const fallbacks = EASY_COLOR_FALLBACK_MAP[targetColor];
    if (fallbacks) {
        for (const fbColor of fallbacks) {
            const v = variants.find(x => x.available && getVariantColor(x) === fbColor);
            if (v) return v;
        }
    }

    // 3) ANY available colour (divert away from the sold-out requested colour).
    const anyInStock = variants.find(v => v.available === true);
    if (anyInStock) return anyInStock;

    // 4) Nothing in stock in any colour: show the requested colour if it exists
    //    (else the first variant) so the card can render as genuinely sold out.
    return variants.find(v => getVariantColor(v) === targetColor) || variants[0] || null;
}

// Legacy function for backward compatibility
function getFirstAvailableVariant(product) {
    return getMatchingVariant(product, null);
}

// ===== Price Rendering =====
function renderCardPrice(container, price, compareAt, currency = null) {
    if (!container) return;

    // Always use $ sign for currency
    currency = '€';

    const p = Number(price) || 0;
    const c = Number(compareAt) || 0;
    const unit = `${currency}${p.toFixed(2)}`;

    if (c > p) {
        // Has discount - show strikethrough compare price and sale price
        const full = `${currency}${c.toFixed(2)}`;
        container.innerHTML = `<s class="compare">${full}</s> <span class="sale">${unit}</span>`;
    } else {
        // Regular price
        container.innerHTML = `<span class="regular">${unit}</span>`;
    }
}

// ===== Card HTML Structure =====
function createSuggestionCardHTML(product, variant, isChecked, soldOut = false) {
    if (!product || !variant) return '';

    const imgUrl = variant.featured_image?.src || product.images?.[0] || '';
    // Out of stock EITHER because the shown variant is unavailable OR because the
    // accessory has no in-stock variant in the currently-selected colour (soldOut).
    // Both → not addable + a "Sold out" badge. (gear-suggestions)
    const inStock = !!variant.available && !soldOut;
    const checkedAttr = (isChecked && inStock) ? 'checked' : '';
    const disabledAttr = !inStock ? 'disabled' : '';
    const soldOutBadge = !inStock ? `<span class="suggestion-sold-out">Sold out</span>` : '';
    const titleAttr = String(product.title || '').replace(/"/g, '&quot;');

    return `
        <li class="suggestion-card ${isChecked ? 'is-added' : ''} ${!inStock ? 'is-sold-out' : ''}" data-handle="${product.handle}" data-variant-id="${variant.id}" title="${titleAttr}">
            <label class="agb-item-checkbox-label">
                <input type="checkbox" class="agb-item-checkbox" ${checkedAttr} ${disabledAttr} aria-label="Add ${product.title}">
            </label>
            <div class="suggested-avatar">
                <div class="suggested-card-img-wrapper">
                    <img class="suggestion-card-img" src="${imgUrl}" alt="${product.title}" loading="lazy">
                </div>
            </div>
            <div class="agb-title suggestion-card-title">${product.title}${soldOutBadge}</div>
            <div class="agb-item-price-container">
                <span class="agb-item-price"></span>
            </div>
        </li>
    `;
}

// ===== Store for checked suggestions =====
const checkedSuggestions = new Set(); // Stores variant IDs of checked suggestions

// ===== Store current selected variant color =====
let currentSelectedColor = null; // Stores the color of the currently selected main product variant

// Whether the LAST render used the panel-managed (dynamic) list. Lets the
// gs-ready handler re-render when a product STOPS being panel-managed (entry
// removed/disabled) so the hardcoded list is restored. (gear-suggestions)
let panelListApplied = false;

// ===== Cart Integration =====
// The shopper's chosen quantity. This widget INTERCEPTS the theme's Add-to-Cart
// (capture phase + stopImmediatePropagation), so the theme's own form submit —
// the thing that normally honours the quantity box — never runs. Both the main
// product and the accessories were hardcoded to 1, which meant ticking any
// suggestion silently threw away the quantity the shopper had chosen.
//
// MUST use form.elements, NOT form.querySelector: the quantity input is rendered
// with a form="…" ATTRIBUTE and lives OUTSIDE the <form> element in the DOM, so a
// querySelector scoped to the form finds nothing. Dorian 2026-07-21.
function _easyBaseQty(form) {
    try {
        const el = form && form.elements ? form.elements['quantity'] : null;
        if (!el) return 1;
        const raw = (typeof el.value === 'string') ? el.value : (el[0] && el[0].value);
        const n = parseInt(raw, 10);
        return (Number.isFinite(n) && n > 0) ? n : 1;
    } catch (e) { return 1; }
}

async function addToCart(mainVariantId, suggestionVariantIds, baseQty) {
    if (!mainVariantId) {
        console.warn('[EasySuggest] Missing main variant ID for cart addition');
        return { ok: false, message: '' };
    }
    const qty = (Number.isFinite(baseQty) && baseQty > 0) ? baseQty : 1;

    // Mark these lines as coming from Easy Suggestions so an order can tell
    // "accepted a suggestion" apart from "built a loadout". Same `_agb_*`
    // properties, different `_agb_source`. Guarded: agb-order-provenance.js
    // failing to load must cost the reporting, never the sale.
    const prov = (role) => {
        try {
            return window.AGB_Provenance
                ? window.AGB_Provenance.props({ role: role, source: 'easy-suggestion' })
                : {};
        } catch (e) { return {}; }
    };

    const post = async (accQty) => {
        // bases NEVER wear builder marks (Dorian 2026-08-12) — only the
        // accessory lines do; their _agb_base_handle names this base
        const items = [{ id: mainVariantId, quantity: qty, properties: {} }];
        if (Array.isArray(suggestionVariantIds)) {
            suggestionVariantIds.forEach(variantId => {
                items.push({ id: variantId, quantity: accQty, properties: prov('accessory') });
            });
        }
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
        });
    };

    try {
        let response = await post(qty);

        // The cart-quantity-cap engine rejects the WHOLE batch with a synthetic
        // 422 when any single line exceeds its per-product limit — and ~70 items
        // (mostly free gifts) are capped at 1. Without this retry, ticking a
        // capped freebie while buying 3 would add NOTHING AT ALL, losing the main
        // purchase too. Retry once with the accessories back at 1.
        if (!response.ok && qty > 1) {
            response = await post(1);
        }

        if (!response.ok) {
            const error = await response.clone().json().catch(() => ({}));
            console.error('[EasySuggest] Cart add failed:', error);
            return { ok: false, message: (error && (error.description || error.message)) || '' };
        }

        return { ok: true, message: '' };
    } catch (e) {
        console.error('[EasySuggest] Cart add error:', e);
        return { ok: false, message: '' };
    }
}

// ===== Cart Refresh and Drawer Opening =====
/**
 * Gets section keys that need refreshing after cart update
 * @returns {string[]} Section keys to refresh
 */
function getSectionKeysToRefresh() {
    const keys = [];

    // Try multiple possible cart drawer selectors
    const cartDrawerSec =
        document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]') ||
        document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]') ||
        document.querySelector('[id^="shopify-section-"][id*="cart"]');

    if (cartDrawerSec) {
        const key = cartDrawerSec.id.replace('shopify-section-', '');
        keys.push(key);
    } else {
        // Fallback: get all sections with "cart" in the ID
        const allCartSections = document.querySelectorAll('[id^="shopify-section-"][id*="cart"]');
        allCartSections.forEach(sec => {
            const key = sec.id.replace('shopify-section-', '');
            keys.push(key);
        });
    }

    // Also get cart icon/bubble section
    const cartIconSec = document.querySelector('[id^="shopify-section-"][id$="__cart-icon-bubble"]');
    if (cartIconSec) {
        const key = cartIconSec.id.replace('shopify-section-', '');
        keys.push(key);
    }

    return Array.from(new Set(keys));
}

/**
 * Fetches fresh HTML for specified sections
 * @param {string[]} keys - Section keys to fetch
 * @returns {Object|null} Sections HTML object
 */
async function fetchSections(keys) {
    if (!keys?.length) return null;
    try {
        const url = `/?sections=${keys.map(encodeURIComponent).join(',')}`;
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error('Sections fetch failed');
        return await res.json();
    } catch (e) {
        console.warn('[EasySuggest] Failed to fetch sections:', e);
        return null;
    }
}

/**
 * Replaces DOM sections with fresh HTML
 * @param {Object} sectionsHTML - Sections HTML object
 */
function replaceSectionsInDom(sectionsHTML) {
    if (!sectionsHTML) return;

    for (const [key, html] of Object.entries(sectionsHTML)) {
        const domId = `shopify-section-${key}`;
        const container = document.getElementById(domId);

        if (!container || typeof html !== 'string') continue;

        // Preserve scroll position for cart drawer
        const isCartDrawer = container.querySelector('cart-drawer');
        let scrollTop = 0;
        if (isCartDrawer) scrollTop = container.scrollTop;

        // Replace HTML
        container.innerHTML = html;

        // Restore scroll position
        if (isCartDrawer) container.scrollTop = scrollTop;
    }
}

/**
 * Opens the cart drawer using various methods
 * @returns {boolean} Success status
 */
function openCartDrawerNow() {
    let cartDrawer = document.querySelector('cart-drawer') ||
                     document.querySelector('#cart-drawer') ||
                     document.querySelector('[id*="cart-drawer"]') ||
                     document.querySelector('[class*="cart-drawer"]');

    if (!cartDrawer) {
        // Try to find it after a short delay
        setTimeout(() => {
            cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) openCartDrawerNow();
        }, 200);
        return false;
    }

    // Try component methods first
    try {
        if (typeof cartDrawer.show === 'function') {
            cartDrawer.show();
            return true;
        }
    } catch {}

    try {
        if (cartDrawer.hasAttribute) {
            cartDrawer.setAttribute('open', '');
            return true;
        }
    } catch {}

    try {
        if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            return true;
        }
    } catch {}

    // Try finding toggle button
    const toggler = document.querySelector(
        '[data-cart-toggle],[data-open-cart],[data-drawer-toggle="cart"],[data-action="open-drawer"],button[aria-controls="cart-drawer"],.js-drawer-open-cart,.js-open-cart-drawer,a[aria-controls="cart-drawer"]'
    );
    if (toggler) {
        toggler.click();
        return true;
    }

    // Dispatch events as fallback
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:show'));
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { target: 'cart' } }));

    // Last resort - add CSS class
    document.body.classList.add('cart-drawer-open');
    return false;
}

/**
 * Refreshes cart UI and opens drawer with updated content
 */
async function refreshCartUI() {
    try {
        // Small delay to ensure Shopify backend has processed the cart add
        await new Promise(resolve => setTimeout(resolve, 50));

        // Fetch cart data
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

        // Get section keys to refresh
        const sectionKeys = getSectionKeysToRefresh();

        if (!sectionKeys.length) {
            // Fallback: just try to open drawer without refresh
            openCartDrawerNow();
            return;
        }

        // Fetch fresh HTML for cart sections
        const sectionsHTML = await fetchSections(sectionKeys);

        if (!sectionsHTML) {
            openCartDrawerNow();
            return;
        }

        // Update DOM with fresh cart HTML
        replaceSectionsInDom(sectionsHTML);

        // Wait for DOM to update
        await new Promise(resolve => setTimeout(resolve, 100));

        // Dispatch events for theme compatibility
        const detail = { 
            cart, 
            sections: sectionsHTML,
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer'
        };
        document.dispatchEvent(new CustomEvent('cart:change', { detail }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail }));

        // Open cart drawer with fresh content
        await new Promise(resolve => setTimeout(resolve, 100));
        openCartDrawerNow();

    } catch (e) {
        console.error('[EasySuggest] Cart refresh failed:', e);
        // Still try to open drawer even if refresh fails
        openCartDrawerNow();
    }
}

// ===== Main Rendering Logic =====
// ── Emplacement slot grouping (ported from the gear builder 2026-07-13) ──────
// Fold accessories that share the same panel `emplacement` tag into ONE card
// with a ‹ › slider + pagination dots — parity with the gear builder. Fully
// inline-styled (no external CSS), so it works on the standard PDP where the
// easy widget lives. Operates on the passed list <ul>; remembers each slot's
// shown option across re-renders (colour changes) via _slotIndexState.
const _slotIndexState = {};
function groupEmplacementSlots(listEl) {
    if (!listEl || !window.__AGB_GEAR_SUGG) return;

    const cards = Array.from(listEl.querySelectorAll('.suggestion-card'));
    const bySlot = {};
    for (const card of cards) {
        const emp = card.dataset && card.dataset.emplacement;
        if (!emp) continue;
        (bySlot[emp] = bySlot[emp] || []).push(card);
    }

    Object.keys(bySlot).forEach(emp => {
        let group = bySlot[emp];
        if (group.length < 2) return;                    // not a multi-option slot
        group = group
            .map((card, i) => ({ card, i, tier: Number(card.dataset.availTier || '0') }))
            .sort((a, b) => (a.tier - b.tier) || (a.i - b.i))
            .map(x => x.card);
        const first = group[0];
        if (first.parentNode && first.parentNode.classList &&
            first.parentNode.classList.contains('agb-slot-track')) return; // already built

        const slot = document.createElement('li');
        slot.className = 'agb-slot';
        slot.style.cssText = 'position:relative;list-style:none;padding:0;margin:0;';
        const viewport = document.createElement('div');
        viewport.className = 'agb-slot-viewport';
        viewport.style.cssText = 'overflow:hidden;width:100%;padding:2px 0;margin:-2px 0;';
        const track = document.createElement('ul');
        track.className = 'agb-slot-track';
        track.style.cssText = 'display:flex;flex-wrap:nowrap;list-style:none;padding:0;margin:0;transition:transform .28s ease;will-change:transform;';
        viewport.appendChild(track);
        slot.appendChild(viewport);
        first.parentNode.insertBefore(slot, first);

        const last = group.length - 1;
        const stripW = 54;
        group.forEach((card, i) => {
            card.classList.add('agb-slot-member');
            card.style.flex = '0 0 100%';
            card.style.width = '100%';
            card.style.maxWidth = '100%';
            card.style.margin = '0';
            card.style.boxSizing = 'border-box';
            card.style.display = '';
            card.style.paddingBottom = '20px';                       // room for the dots
            card.style.paddingLeft = (i > 0) ? stripW + 'px' : '';   // room for ‹
            card.style.paddingRight = (i < last) ? stripW + 'px' : ''; // room for ›
            track.appendChild(card);
        });

        const mkArrow = (glyph, side, label) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'agb-slot-arrow agb-slot-' + side;
            b.textContent = glyph;
            b.setAttribute('aria-label', label);
            b.style.cssText = 'position:absolute;top:50%;' + side + ':6px;transform:translateY(-50%);z-index:4;' +
                'border:none;background:none;cursor:pointer;padding:2px 6px;' +
                'color:#1c1c1c;font:700 40px/1 system-ui,sans-serif;' +
                'align-items:center;justify-content:center;';
            return b;
        };
        const prev = mkArrow('‹', 'left', 'Previous option');
        const next = mkArrow('›', 'right', 'Next option');
        slot.appendChild(prev);
        slot.appendChild(next);

        const dots = document.createElement('div');
        dots.className = 'agb-slot-dots';
        dots.style.cssText = 'position:absolute;left:50%;bottom:4px;transform:translateX(-50%);' +
            'display:flex;gap:6px;z-index:4;line-height:0;';
        const dotEls = group.map((_, i) => {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'agb-slot-dot';
            d.setAttribute('aria-label', 'Option ' + (i + 1) + ' of ' + group.length);
            d.style.cssText = 'width:7px;height:7px;border-radius:50%;padding:0;cursor:pointer;' +
                'border:1px solid #1c1c1c;background:transparent;box-sizing:border-box;';
            d.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); goTo(i); });
            dots.appendChild(d);
            return d;
        });
        slot.appendChild(dots);

        let idx = group.findIndex(c => c.classList.contains('is-added'));
        if (idx < 0) idx = _slotIndexState[emp];
        if (typeof idx !== 'number' || idx < 0 || idx >= group.length) idx = 0;
        const render = () => {
            track.style.transform = 'translateX(' + (-idx * 100) + '%)';
            prev.style.display = idx > 0 ? 'flex' : 'none';
            next.style.display = idx < group.length - 1 ? 'flex' : 'none';
            dotEls.forEach((d, i) => { d.style.background = (i === idx) ? '#1c1c1c' : 'transparent'; });
        };
        const goTo = (i) => {
            idx = Math.max(0, Math.min(group.length - 1, i));       // clamp, no wrap
            _slotIndexState[emp] = idx;
            render();
        };
        const go = (delta) => goTo(idx + delta);
        prev.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); go(-1); });
        next.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); go(1); });
        render();
    });
}

async function renderSuggestionCards(targetColor = null) {
const productSuggestionContainer = document.querySelector('.product-suggestion');
    if (!productSuggestionContainer) {
        console.warn('[EasySuggest] Container .product-suggestion not found');
        return;
    }

    if (!currentProductHandle) {
        console.warn('[EasySuggest] Product handle not found');
        return;
    }

    // Panel-managed dynamic list (gear-suggestions): an entry flagged enabled +
    // easyEnabled wholesale-replaces the hardcoded list for this product (order =
    // panel order, enabled accessories only); no entry / flags off / global
    // undefined -> hardcoded SUGGESTION_LIST. FAIL-SAFE.
    const dyn = window.__AGB_GEAR_SUGG;
    const dynEntry = dyn && dyn.byProduct && dyn.byProduct[currentProductHandle];
    // Require >=1 LIVE accessory: an enabled entry with none must fall back to
    // the hardcoded list, not blank the checklist (shoppers would see nothing).
    const useDynList = !!(dynEntry && dynEntry.enabled && dynEntry.easyEnabled
        && (dynEntry.accessories || []).some(a => a && a.enabled));
    panelListApplied = useDynList;
    const suggestions = useDynList
        ? (dynEntry.accessories || []).filter(a => a && a.enabled).map(a => [a.handle])
        : SUGGESTION_LIST[currentProductHandle];
    // Emplacement (slot) tag per handle — the same panel field the gear builder
    // groups by. Only when the panel list applies (hardcoded easy has no slots).
    const empByHandle = {};
    if (useDynList) {
        (dynEntry.accessories || []).forEach(a => {
            if (a && a.enabled && a.emplacement) empByHandle[a.handle] = String(a.emplacement).trim();
        });
    }
    if (!suggestions || !Array.isArray(suggestions) || suggestions.length === 0) {
        // No suggestions for this product
        productSuggestionContainer.innerHTML = '';
        return;
    }

    // Create container for cards
    const cardsList = document.createElement('ul');
    cardsList.className = 'suggestions-list';
    cardsList.style.listStyle = 'none';
    cardsList.style.padding = '0';
    cardsList.style.margin = '0';
    cardsList.style.display = 'flex';
    cardsList.style.flexDirection = 'column';
    cardsList.style.gap = '1rem';

    // Use DocumentFragment for batch DOM insertion
    const fragment = document.createDocumentFragment();

    // Flatten suggestions (handle both strings and nested arrays)
    const flattenedSuggestions = suggestions.flat().filter(h => typeof h === 'string' && h.length > 0);
    
    // Fetch all products in parallel
    const fetchPromises = flattenedSuggestions.map(handle => fetchProductData(handle));
    const products = await Promise.all(fetchPromises);

    // Render cards
    // Sold-out add-ons are HIDDEN by default; the panel `showSoldOut` opt-in
    // shows them (dimmed "Sold out"). Matches the gear builder.
    const showSoldOut = !!(window.__AGB_GEAR_SUGG && window.__AGB_GEAR_SUGG.raw && window.__AGB_GEAR_SUGG.raw.showSoldOut === true);
    products.forEach((product, index) => {
        if (!product) {
            console.warn('[EasySuggest] Failed to fetch product:', flattenedSuggestions[index]);
            return;
        }

        // Check if product has any available variants at all
        const hasAvailableVariant = product.variants && product.variants.some(v => v.available === true);
        if (!hasAvailableVariant && !showSoldOut) {
            // Skip products with no available variants
            console.log('[EasySuggest] Skipping product with no available variants:', product.handle);
            return;
        }

        // Pick the display variant — already substitutes the next available
        // colour when the requested colour is sold out (see getMatchingVariant).
        const variant = getMatchingVariant(product, targetColor);
        if (!variant) {
            console.warn('[EasySuggest] No variant found for product:', product.handle);
            return;
        }

        // Sold out = the PICKED variant is unavailable. getMatchingVariant already
        // walked requested colour → preferred substitutes → any available colour,
        // so an unavailable pick means NO colour is in stock at all — only then is
        // the card genuinely sold out. A colour merely out of stock now resolves to
        // the next available colour instead of a grey "Sold out".
        const soldOut = !variant.available;

        const cardHTML = createSuggestionCardHTML(product, variant, false, soldOut);
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cardHTML.trim();
        const card = tempDiv.firstElementChild;

        if (card) {
            // Slot tag for groupEmplacementSlots() (panel list only; '' otherwise).
            card.dataset.emplacement = empByHandle[product.handle] || '';
            // Render price
            const priceEl = card.querySelector('.agb-item-price');
            if (priceEl && variant) {
                renderCardPrice(
                    priceEl,
                    (Number(variant.price) || 0) / 100,
                    (Number(variant.compare_at_price) || 0) / 100
                );
            }

            // Add checkbox event handler
            const checkbox = card.querySelector('.agb-item-checkbox');
            if (checkbox) {
                const toggleCheckbox = (e) => {
                    e.stopPropagation();
                    const isChecked = checkbox.checked;

                    if (isChecked) {
                        // Store suggestion variant ID (don't add to cart yet)
                        checkedSuggestions.add(variant.id);
                        card.classList.add('is-added');
                    } else {
                        // Remove from checked suggestions
                        checkedSuggestions.delete(variant.id);
                        card.classList.remove('is-added');
                    }
                };

                checkbox.addEventListener('change', toggleCheckbox);

                // Make the whole card clickable to toggle checkbox
                card.addEventListener('click', (e) => {
                    // Don't toggle if clicking directly on the checkbox (it will handle itself)
                    if (e.target === checkbox || e.target.closest('.agb-item-checkbox-label')) {
                        return;
                    }
                    // Toggle checkbox when clicking anywhere else on the card
                    checkbox.checked = !checkbox.checked;
                    // Trigger change event manually
                    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                });
            }

            fragment.appendChild(card);
        }
    });

    cardsList.appendChild(fragment);
    productSuggestionContainer.innerHTML = '';
    productSuggestionContainer.appendChild(cardsList);

    // Fold same-emplacement cards into one slot slider (panel config only) —
    // parity with the gear builder. Runs BEFORE placement so the count below is
    // SLOTS, not raw cards.
    try { groupEmplacementSlots(cardsList); } catch (e) { /* non-fatal */ }

    // Panel-managed placement: above/below the ATC button by rendered count vs
    // the per-device threshold (gear-suggestions easyPlacement).
    placeEasySuggestionWidget(productSuggestionContainer, cardsList.children.length);
}

// Move the easy-suggestion widget above/below the add-to-cart button based on the
// rendered add-on count vs the panel's per-device threshold (gear-suggestions
// config `easyPlacement`). ABOVE when count <= threshold, else BELOW. 0 / no
// config => leave the default DOM position (below the ATC). Fail-safe: any hiccup
// leaves the default placement.
function placeEasySuggestionWidget(container, count) {
    try {
        const gs = window.__AGB_GEAR_SUGG;
        const ep = gs && gs.raw && gs.raw.easyPlacement;
        if (!ep) return;
        const isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 740px)').matches);
        const threshold = isMobile ? ep.mobileThreshold : ep.desktopThreshold;
        if (!threshold || threshold < 1) return; // 0 / unset => default (below)
        const above = count <= threshold;

        const buy = document.querySelector('buy-buttons.buy-buttons') ||
                    document.querySelector('.buy-buttons') ||
                    document.querySelector('product-form');
        if (!buy) return;
        const parent = container.parentElement;
        if (!parent) return;
        // Walk the ATC element up to the child of `parent` that contains it — that
        // block is what we position `.product-suggestion` before/after.
        let anchor = buy;
        while (anchor && anchor.parentElement !== parent) anchor = anchor.parentElement;
        if (!anchor || anchor === container) return; // not in a shared parent

        const containerBeforeAnchor = !!(anchor.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_PRECEDING);
        if (above && !containerBeforeAnchor) {
            parent.insertBefore(container, anchor);            // move above the ATC block
        } else if (!above && containerBeforeAnchor) {
            parent.insertBefore(container, anchor.nextElementSibling); // move back below
        }
    } catch (e) { /* non-fatal — keep default placement */ }
}

// Re-run placement without a full re-render (e.g. the viewport crossed the
// desktop/mobile breakpoint). Uses the already-rendered card count.
function reflowEasyPlacement() {
    const container = document.querySelector('.product-suggestion');
    if (!container) return;
    const count = container.querySelectorAll('.suggestion-card').length;
    if (count > 0) placeEasySuggestionWidget(container, count);
}

// ===== CSS Styling for Horizontal Layout =====
function injectStyles() {
    // Check if styles already injected
    if (document.getElementById('easy-suggestion-styles')) return;

    const style = document.createElement('style');
    style.id = 'easy-suggestion-styles';
    style.textContent = `
        /* Horizontal layout for suggestion cards in .product-suggestion */
        .product-suggestion .suggestion-card {
            display: flex !important;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem;
            border: 1px solid #c3c6d4;
            border-radius: 2px;
            background-color: #fff;
            max-width: 100%;
            min-width: 0;
            overflow: hidden;
            cursor: pointer;
        }

        .product-suggestion .suggestion-card.is-added {
            background-color: #0000001a;
        }

        .product-suggestion .agb-item-checkbox-label {
            display: flex;
            flex-shrink: 0;
            margin: 0;
        }

        .product-suggestion .agb-item-checkbox {
            width: 26px;
            height: 26px;
            cursor: pointer;
            flex-shrink: 0;
        }

        .product-suggestion .suggested-avatar {
            display: flex;
            flex-shrink: 0;
            margin: 0;
            padding: 0;
        }

        .product-suggestion .suggested-card-img-wrapper {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 2px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            aspect-ratio: 1/1;
            mix-blend-mode: multiply;
        }

        .product-suggestion .suggestion-card-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform .3s ease;
            transform: scale(1.3);
        }

        /* Out of stock in the selected colour (gear-suggestions) */
        .product-suggestion .suggestion-card.is-sold-out { opacity: 0.6; }
        .product-suggestion .suggestion-card.is-sold-out .agb-item-checkbox-label { cursor: not-allowed; }
        .product-suggestion .suggestion-sold-out {
            display: inline-block;
            margin-left: 6px;
            padding: 1px 6px;
            font-size: 10px;
            font-weight: 700;
            letter-spacing: .03em;
            text-transform: uppercase;
            color: #fff;
            background: #8f1814;
            border-radius: 3px;
            vertical-align: middle;
        }

        .product-suggestion .suggestion-card-title {
            flex: 1;
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.4;
            text-align: left;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            margin: 0;
            padding: 0 0.5rem;
            color: #1f2937;
        }

        .product-suggestion .agb-item-price-container {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: flex-end;
            margin: 0;
            padding: 0;
        }

        .product-suggestion .agb-item-price {
            display: inline-flex;
            flex-direction: column;
            align-items: flex-end;
            white-space: normal;
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.15;
        }

        .product-suggestion .agb-item-price .compare {
            order: 2;
            color: #6b7280;
            text-decoration: line-through;
            margin-right: 0;
            font-size: 0.82em;
            opacity: 0.65;
        }

        .product-suggestion .agb-item-price .sale {
            order: 1;
            color: #dc2626;
            font-weight: 600;
        }

        .product-suggestion .agb-item-price .regular {
            color: #1f2937;
        }

        .product-suggestion .suggestions-list {
            list-style: none;
            padding: 0;
            margin: 0.5rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    `;
    document.head.appendChild(style);
}

// ===== Intercept Add to Cart Button =====
function setupAddToCartInterceptor() {
    // Wait a bit for buttons to be available
    const checkForButtons = () => {
        // Find all add to cart buttons - try multiple selectors
        const atcButtons = document.querySelectorAll(
            '#add-all-btn, #add-all-btn-2, .js-add-all, ' +
            'button[type="submit"][form*="product-form"], ' +
            'buy-buttons button[type="submit"], ' +
            'form[action*="/cart/add"] button[type="submit"]'
        );
        
        atcButtons.forEach(button => {
            // Check if already intercepted
            if (button.dataset.easySuggestIntercepted) return;
            button.dataset.easySuggestIntercepted = 'true';

            // Use capture phase to intercept before other handlers
            const handleAtcClick = async (e) => {
                // Only intercept if there are checked suggestions
                if (checkedSuggestions.size === 0) {
                    // No suggestions checked, let default behavior proceed
                    return;
                }

                // Prevent default add to cart behavior
                e.stopImmediatePropagation();
                e.preventDefault();

                // Get main product variant ID from form
                // First try to get form from button's form attribute
                let form = null;
                if (button.form) {
                    form = button.form;
                } else if (button.getAttribute('form')) {
                    form = document.getElementById(button.getAttribute('form'));
                }
                
                // Fallback to other selectors
                if (!form) {
                    form = document.querySelector('form[action*="/cart/add"]') || 
                           document.querySelector('form input[name="id"]')?.closest('form') ||
                           document.querySelector(`form#${window.AGB_FORM_ID || 'product-form'}`);
                }
                
                const mainVariantId = form?.querySelector('input[name="id"]')?.value;

                if (!mainVariantId) {
                    console.warn('[EasySuggest] Main product variant ID not found');
                    // Can't proceed without main variant ID
                    return;
                }

                // Show loading state
                const originalText = button.textContent;
                const wasDisabled = button.disabled;
                button.disabled = true;
                button.textContent = 'Adding...';

                // Get all checked suggestion variant IDs
                const suggestionVariantIds = Array.from(checkedSuggestions);

                // Add to cart: main product + all checked suggestions, at the
                // quantity the shopper actually chose.
                const baseQty = _easyBaseQty(form);
                const result = await addToCart(mainVariantId, suggestionVariantIds, baseQty);
                const success = !!(result && result.ok);

                if (success) {
                    // Success - clear checked suggestions and reset button
                    checkedSuggestions.clear();
                    // Reset all checkboxes
                    document.querySelectorAll('.product-suggestion .agb-item-checkbox').forEach(cb => {
                        cb.checked = false;
                    });
                    document.querySelectorAll('.product-suggestion .suggestion-card.is-added').forEach(card => {
                        card.classList.remove('is-added');
                    });

                    button.textContent = 'Added!';
                    
                    // Refresh cart UI and open drawer
                    await refreshCartUI();

                    setTimeout(() => {
                        button.textContent = originalText;
                        button.disabled = wasDisabled;
                    }, 1000);
                } else {
                    // Failed - revert button AND say why. Silently restoring the
                    // label produced a dead button with no explanation, which is
                    // exactly what a cap block or an out-of-stock 422 looked like.
                    button.textContent = originalText;
                    button.disabled = wasDisabled;
                    const msg = (result && result.message) ? result.message : '';
                    if (msg) {
                        try {
                            if (window.SE_Engine && typeof window.SE_Engine.toast === 'function') {
                                window.SE_Engine.toast(msg);
                            } else if (window.AGB && window.AGB.utils && typeof window.AGB.utils.toast === 'function') {
                                window.AGB.utils.toast(msg);
                            } else {
                                alert(msg);
                            }
                        } catch (e) { /* never let feedback break the flow */ }
                    }
                }
            };
            
            button.addEventListener('click', handleAtcClick, true); // Use capture phase to intercept before other handlers
        });
    };

    // Check immediately and also after DOM is ready
    checkForButtons();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(checkForButtons, 100); // Small delay to ensure buttons are rendered
        });
    } else {
        setTimeout(checkForButtons, 100);
    }

    // Also watch for dynamically added buttons
    const observer = new MutationObserver(() => {
        checkForButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

// ===== Variant Change Listener =====
function setupVariantChangeListener() {
    // Listen for variant:change events from the product form
    const form = document.querySelector('form[action*="/cart/add"]') || 
                 document.querySelector('form input[name="id"]')?.closest('form');
    
    if (form) {
        form.addEventListener('variant:change', (e) => {
            const variant = e.detail?.variant;
            if (variant) {
                // Extract color from the selected variant
                const newColor = getVariantColor(variant);
                
                // Only update if color actually changed
                if (newColor !== currentSelectedColor) {
                    currentSelectedColor = newColor;
                    // Clear checked suggestions when variant changes (different variants now)
                    checkedSuggestions.clear();
                    // Re-render suggestion cards with new color
                    renderSuggestionCards(newColor);
                }
            }
        });
    }
    
    // Also listen for changes on the variant input directly
    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                         document.querySelector('form input[name="id"]');
    
    if (variantInput) {
        variantInput.addEventListener('change', async () => {
            // Get the current variant ID from the form
            const variantId = variantInput.value;
            if (!variantId) return;
            
            // Get the main product data
            const product = window.ShopifyProduct;
            if (!product || !product.variants) return;
            
            // Find the variant object
            const variant = product.variants.find(v => String(v.id) === String(variantId));
            if (variant) {
                const newColor = getVariantColor(variant);
                if (newColor !== currentSelectedColor) {
                    currentSelectedColor = newColor;
                    // Clear checked suggestions when variant changes
                    checkedSuggestions.clear();
                    renderSuggestionCards(newColor);
                }
            }
        });
    }
}

// ===== Initialize =====
// Inject styles first
injectStyles();

// Setup add to cart interceptor
setupAddToCartInterceptor();

// Setup variant change listener
setupVariantChangeListener();

// Re-place the widget when the viewport crosses the desktop/mobile breakpoint
// (the threshold differs per device). Debounced; no re-fetch, just a DOM move.
let _easyPlacementResizeTimer = null;
window.addEventListener('resize', () => {
    if (_easyPlacementResizeTimer) clearTimeout(_easyPlacementResizeTimer);
    _easyPlacementResizeTimer = setTimeout(reflowEasyPlacement, 200);
});

// Re-render when the panel-managed suggestion config (re)publishes —
// gear-suggestions-config.js dispatches 'agb:gs-ready' on every publish. Guards:
//   1. only re-render when the publish changes THIS product's list (an entry
//      applies now, or one was applied last render) — most products have none
//      and must not churn;
//   2. clear checkedSuggestions FIRST: the repaint rebuilds every card unchecked,
//      so a variant id left in the Set would be invisible yet still added to cart.
document.addEventListener('agb:gs-ready', () => {
    const dyn = window.__AGB_GEAR_SUGG;
    const dynEntry = dyn && dyn.byProduct && dyn.byProduct[currentProductHandle];
    const applies = !!(dynEntry && dynEntry.enabled && dynEntry.easyEnabled);
    if (!applies && !panelListApplied) return;
    checkedSuggestions.clear();
    renderSuggestionCards(currentSelectedColor);
});

// Wait for DOM to be ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        // Get initial variant color if available
        const form = document.querySelector('form[action*="/cart/add"]') || 
                     document.querySelector('form input[name="id"]')?.closest('form');
        if (form) {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
                const product = window.ShopifyProduct;
                if (product && product.variants) {
                    const variant = product.variants.find(v => String(v.id) === String(variantInput.value));
                    if (variant) {
                        currentSelectedColor = getVariantColor(variant);
                    }
                }
            }
        }
        renderSuggestionCards(currentSelectedColor);
    });
} else {
    // Get initial variant color if available
    const form = document.querySelector('form[action*="/cart/add"]') || 
                 document.querySelector('form input[name="id"]')?.closest('form');
    if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
            const product = window.ShopifyProduct;
            if (product && product.variants) {
                const variant = product.variants.find(v => String(v.id) === String(variantInput.value));
                if (variant) {
                    currentSelectedColor = getVariantColor(variant);
                }
            }
        }
    }
    renderSuggestionCards(currentSelectedColor);
}
